import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "tabs-section" }
const _hoisted_2 = { class: "col-md-10 col-lg-9 col-xl-8" }
const _hoisted_3 = { class: "row-section" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "title col-md-4 col-sm-4" }, [
  /*#__PURE__*/_createTextVNode(" Manufacturer Name "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1)
const _hoisted_5 = { class: "col-md-8 col-sm-8" }
const _hoisted_6 = { class: "row-section" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "title col-md-4 col-sm-4" }, [
  /*#__PURE__*/_createTextVNode(" MPN/Model # "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1)
const _hoisted_8 = { class: "col-md-8 col-sm-8" }
const _hoisted_9 = { class: "row-section" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "title col-md-4 col-sm-4" }, [
  /*#__PURE__*/_createTextVNode(" Product Name "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1)
const _hoisted_11 = { class: "col-md-8 col-sm-8" }
const _hoisted_12 = { class: "row-section" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "title col-md-4 col-sm-4" }, [
  /*#__PURE__*/_createTextVNode(" Condition "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1)
const _hoisted_14 = { class: "col-md-8 col-sm-8" }
const _hoisted_15 = { class: "row-section" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "title col-md-4 col-sm-4" }, "Lot #", -1)
const _hoisted_17 = { class: "col-md-8 col-sm-8" }
const _hoisted_18 = { class: "col-md-6" }
const _hoisted_19 = { class: "row-section" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "title col-md-4 col-sm-4" }, "Expiration Date", -1)
const _hoisted_21 = { class: "col-md-8 col-sm-8" }
const _hoisted_22 = { class: "col-md-6" }
const _hoisted_23 = { class: "row-section" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "title col-md-4 col-sm-4" }, "RX Only", -1)
const _hoisted_25 = { class: "col-md-8 col-sm-8" }
const _hoisted_26 = { class: "col-md-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select_filter = _resolveComponent("v-select-filter")!
  const _component_v_error_text = _resolveComponent("v-error-text")!
  const _component_v_input = _resolveComponent("v-input")!
  const _component_v_form_dropdown = _resolveComponent("v-form-dropdown")!
  const _component_date_picker = _resolveComponent("date-picker")!
  const _component_Toggle = _resolveComponent("Toggle")!
  const _component_add_product_modal = _resolveComponent("add-product-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_v_select_filter, {
              options: _ctx.manufacturers,
              placeholder: "Manufacturer Name",
              modelValue: _ctx.store.manufacturer,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.store.manufacturer) = $event)),
              loading: _ctx.manufacturersLoading,
              onItemsSearch: _ctx.onManufacturersSearch,
              setValueToStore: ""
            }, null, 8, ["options", "modelValue", "loading", "onItemsSearch"]),
            _createVNode(_component_v_error_text, { error: _ctx.manufacturerError }, null, 8, ["error"]),
            (!_ctx.manufacturersLoading && _ctx.manufacturers?.length === 0)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: "text-decoration-underline cursor-pointer mt-2",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openModal(_ctx.MANUFACTURER))),
                  onKeydown: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openModal(_ctx.MANUFACTURER)))
                }, "Ask HANDLE to add ", 32))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_v_select_filter, {
              options: _ctx.mpn,
              placeholder: "MPN or SKU",
              modelValue: _ctx.store.mpn,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.store.mpn) = $event)),
              disabled: !_ctx.mpn?.length,
              loading: _ctx.productsLoading,
              onItemsSearch: _ctx.onMpnSearch
            }, null, 8, ["options", "modelValue", "disabled", "loading", "onItemsSearch"]),
            _createVNode(_component_v_error_text, { error: _ctx.mpnError }, null, 8, ["error"]),
            (
                !(_ctx.productsLoading && _ctx.manufacturersLoading) &&
                _ctx.manufacturers?.length > 0 &&
                _ctx.mpn?.filter((mpnItem) => mpnItem.name.toLowerCase().includes(_ctx.productSearchValue.toLowerCase()))
                  .length === 0
              )
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openModal(_ctx.MPN))),
                  onKeydown: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openModal(_ctx.MPN))),
                  class: "text-decoration-underline cursor-pointer mt-2"
                }, "Ask HANDLE to add", 32))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_v_input, {
              type: "text",
              placeholder: "Product Name",
              value: _ctx.productName,
              disabled: ""
            }, null, 8, ["value"])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_v_form_dropdown, {
              items: _ctx.conditions,
              title: "Please select a condition",
              onItemSelect: _cache[6] || (_cache[6] = ($event: any) => (_ctx.store.conditionId = $event)),
              value: _ctx.store.conditionName
            }, null, 8, ["items", "value"])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_v_input, {
                modelValue: _ctx.store.lotNumber,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.store.lotNumber) = $event)),
                type: "text"
              }, null, 8, ["modelValue"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createVNode(_component_date_picker)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _hoisted_24,
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createVNode(_component_Toggle, {
                modelValue: _ctx.store.rxOnly,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.store.rxOnly) = $event)),
                "on-label": "Yes",
                "off-label": "No"
              }, null, 8, ["modelValue"])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("button", {
      class: "tabs-actions btn btn-secondary",
      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onChangeTab('next')))
    }, "Next"),
    _createVNode(_component_add_product_modal, {
      openModal: _ctx.openProductModal,
      onSetModal: _ctx.setModal,
      "manufacturer-name": _ctx.store?.manufacturer?.name,
      "mpn-name": _ctx.store?.mpn?.name
    }, null, 8, ["openModal", "onSetModal", "manufacturer-name", "mpn-name"])
  ]))
}